export default __webpack_public_path__ + "static/media/cross.88435e72.png";